import { logger } from '@gem/modules/logger';
import { platformInfo } from '@gem/utils';

export function registerSW(): void {
  if (!platformInfo.isElectron && 'serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker
        .register(`/service-worker.js?&version=${window.app.version}`)
        .then((registration) => {
          logger.get('MAIN').log('SW registered: ', registration);
        })
        .catch((registrationError) => {
          logger.get('MAIN').error('SW registration failed: ', registrationError);
        });
    });
  }
}
